import { $api } from '@/shared/api/axiosInstance';
import { UserData } from '../model/types/userTypes';

export const userDataQuery = async () => {
    const url = '/api/v1/users/full';

    const data = await $api.get<UserData>(url);

    return data;
};
